import { RequestStatus } from "@/types/request";

export const REQUEST_STATUS_OPTIONS = [
  { value: RequestStatus.NEW_TASK, label: "New task" },
  { value: RequestStatus.APPROVED, label: "Approved" },
  { value: RequestStatus.TO_DO, label: "To do" },
  { value: RequestStatus.IN_PROGRESS, label: "In progress" },
  { value: RequestStatus.ON_HOLD, label: "On hold" },
  { value: RequestStatus.COMPLETED, label: "Completed" },
  { value: RequestStatus.DONE, label: "Done" },
  { value: RequestStatus.CANCELED, label: "Cancelled" },
] as const;

export const REQUEST_PRIORITIES = [
  { value: false, label: "Normal" },
  { value: true, label: "Star" },
] as const;

export const getStatusLabel = (status: RequestStatus): string => {
  return (
    REQUEST_STATUS_OPTIONS?.find((opt) => opt.value === status)?.label || status
  );
};

export const getStatusOptionsForSelect = () => {
  return REQUEST_STATUS_OPTIONS?.map((status) => ({
    value: status.value,
    label: status.label,
  }));
};

const REQUEST_STATUS_TRANSITIONS: Record<RequestStatus, RequestStatus[]> = {
  [RequestStatus.NEW_TASK]: [
    RequestStatus.APPROVED,
    RequestStatus.ON_HOLD,
    RequestStatus.CANCELED,
  ],
  [RequestStatus.APPROVED]: [
    RequestStatus.TO_DO,
    RequestStatus.ON_HOLD,
    RequestStatus.CANCELED,
  ],
  [RequestStatus.TO_DO]: [
    RequestStatus.IN_PROGRESS,
    RequestStatus.ON_HOLD,
    RequestStatus.CANCELED,
  ],
  [RequestStatus.IN_PROGRESS]: [
    RequestStatus.ON_HOLD,
    RequestStatus.COMPLETED,
    RequestStatus.CANCELED,
  ],
  [RequestStatus.ON_HOLD]: [
    RequestStatus.TO_DO,
    RequestStatus.IN_PROGRESS,
    RequestStatus.CANCELED,
  ],
  [RequestStatus.COMPLETED]: [RequestStatus.TO_DO, RequestStatus.DONE],
  [RequestStatus.DONE]: [],
  [RequestStatus.CANCELED]: [RequestStatus.NEW_TASK, RequestStatus.APPROVED],
};

export const getAllowedStatusValuesForTask = (
  currentStatus: string,
): RequestStatus[] =>
  REQUEST_STATUS_TRANSITIONS[currentStatus as RequestStatus] ??
  REQUEST_STATUS_OPTIONS.map((option) => option.value);

export const getAllowedStatusesForTask = (
  currentStatus: string,
): { value: RequestStatus; label: string }[] => {
  return getAllowedStatusValuesForTask(currentStatus).map((value) => ({
    value,
    label:
      REQUEST_STATUS_OPTIONS.find((option) => option.value === value)?.label ??
      value,
  }));
};
